export default "__VITE_ASSET__CZL_QWny__"